import BaseService from "../BaseService";
import _ from "lodash";

class ProductOptionService extends BaseService {
    list = async ({ info } = {}) => {
        var data = await this._api.get("/product_option/list", { params: { info: info } });
        return data;
    };

    update = async ({ id, title }) => {
        var data = await this._api.post(`/product_option/update`, { id, title });
        return data;
    };

    create = async ({ title }) => {
        var data = await this._api.post(`/product_option/create`, { title });
        return data;
    };


    get = async (id) => {
        var data = await this._api.get(`/product_option/get`, { params: { id: id } });
        return data;
    };


    delete = async (id) => {
        var data = await this._api.post(`/product_option/delete`, { id: id });
        return data;
    };


    createValue = async ({ title, parent_id }) => {
        var data = await this._api.post(`/product_option/create_value`, { title, parent_id });
        return data;
    };



    updateValue = async ({ title, id, parent_id }) => {
        var data = await this._api.post(`/product_option/update_value`, { title, parent_id, id });
        return data;
    };

    
    deleteValue = async ({id, parent_id }) => {
        var data = await this._api.post(`/product_option/delete_value`, { parent_id, id });
        return data;
    };





    // createParentOption = async ({ id, title, parent_id }) => {
    //     var data = await this._api.post(`/product_option/createparentoption`, {title});
    //     return data;
    // };

    // updateGeneralInfoParent=async ({ id, title, parent_id }) => {
    //     var data = await this._api.post(`/product_option/updategeneralinfoparent`, { id, title});
    //     return data;
    // };

    // get = async (id,parent_id) => {
    //     var data = await this._api.get(`/product_option/get`, { params: { id: id, parent_id : parent_id } });
    //     return data;
    // };

    // getparent = async (id,parent_id) => {
    //     var data = await this._api.get(`/product_option/getparent`, { params: { id: id} });
    //     return data;
    // };

    // delete = async (id,parent_id) => {
    //     var data = await this._api.post(`/product_option/delete`, {  id: id, parent_id : parent_id });
    //     return data;
    // };


    // deleteParentOption = async (id) => {
    //     var data = await this._api.post(`/product_option/deleteparentoption`, {  id: id });
    //     return data;
    // };

}
export default ProductOptionService;
